function DashboardActiveWeather( {value} ) {
    const getRainIntensityPercent = (v) => {
        const percent = v === 0 ? "0%" 
                        : v === 1 ? "20%" 
                        : v === 2 ? "40%" 
                        : v === 3 ? "60%" 
                        : v === 4 ? "80%" 
                        : v === 5 ? "100%" 
                        : "0%" 

        return `${percent}`;
    };

    const getRainIntensityIcon = (v) => {
        const icon_name = v === 0 ? "wb_sunny" 
                        : v === 1 || v === 2 || v === 3 ? "rainy" 
                        : v === 4 || v === 5 ? "thunderstorm" 
                        : "wb_sunny" 

        return `${icon_name}`;
    };

    const getRainIntensityTextColor = (v) => {
        const text_color = v === 0 || v === 1 || v === 2 ? "text-acc-cyan"  
                        : v === 3 || v === 4 || v === 5 ? "text-acc-blue" 
                        : "text-acc-cyan" 

        return `${text_color} text-[10px] font-bold`;
    };

    const getRainIntensityIconColor = (v) => {
        const icon_color = v === 0 ? "text-acc-yellow"  
                        : v === 1 || v === 2 ? "text-acc-cyan"
                        : v === 3 || v === 4 || v === 5 ? "text-acc-blue" 
                        : "text-acc-yellow" 

        return `${icon_color} material-symbols-outlined text-lg`;
    };

    return (
        <div className="flex h-10 items-center gap-4 rounded border border-[#324d67] bg-[#111a22]/50 px-3">
            <div className="flex items-center gap-2">
                    <div className="flex flex-col items-end">
                        <span className="text-[8px] text-[#92adc9] uppercase font-bold">+10 min</span>
                        <span className={getRainIntensityTextColor(value["10-rain-intensity"])}>{getRainIntensityPercent(value["10-rain-intensity"])} Rain</span>
                    </div>
                    <span className={getRainIntensityIconColor(value["10-rain-intensity"])}>{getRainIntensityIcon(value["10-rain-intensity"])}</span>
            </div>

            <div className="w-px h-6 bg-[#233648]"></div>

            <div className="flex items-center gap-2">
                <div className="flex flex-col items-end">
                    <span className="text-[8px] text-[#92adc9] uppercase font-bold">+30 min</span>
                    <span className={getRainIntensityTextColor(value["30-rain-intensity"])}>{getRainIntensityPercent(value["30-rain-intensity"])}% Rain</span>
                </div>
                <span className={getRainIntensityIconColor(value["30-rain-intensity"])}>{getRainIntensityIcon(value["10-rain-intensity"])}</span>
            </div>
        </div>
    );
}

export default DashboardActiveWeather;